module.exports = __webpack_public_path__ + "media/icons/ferry-c889e7e5.svg";